import React from "react";

const ErrorShow = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <img src="./error.svg" alt="" style={{ maxWidth: "100%" }} />
    </div>
  );
};

export default ErrorShow;
